<template>
  <v-dialog style="background-color: wheat" v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ currentEvaluation ? currentEvaluation.title : 'Đánh giá học sinh' }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="pa-6">
        <v-row style="overflow-x: hidden">
          <v-col cols="12" md="3">
            <ListEvaluateStudent
              :evaluationId="currentEvaluation ? currentEvaluation.id : ''"
              :classId="currentEvaluation && currentEvaluation.class ? currentEvaluation.class.id : ''"
              @student-selected="selectStudent"
              ref="listEvaluateStudent"
            />
          </v-col>

          <v-col cols="6">
            <CriterialForStudent
              :selectedStudent="selectedStudent"
              :evaluationCriteria="evaluationCriteria"
              :currentEvaluation="currentEvaluation"
              ref="criterialForStudent"
            />
          </v-col>
          <v-col cols="3">
            <NotesForEvaluate :currentEvaluation="currentEvaluation" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ListEvaluateStudent from '@/modules/evaluate/ListEvaluateStudent.vue'
import CriterialForStudent from '@/modules/evaluate/CriterialForStudent.vue'
import NotesForEvaluate from '@/modules/evaluate/NotesForEvaluate.vue'

export default {
  components: {
    ListEvaluateStudent,
    CriterialForStudent,
    NotesForEvaluate,
  },
  data() {
    return {
      dialog: false,
      selectedStudent: null,
      selectedStudentIndex: null,
      evaluationCriteria: [],
      currentEvaluation: null,
    }
  },
  computed: {
    ...mapGetters('evaluateStudent', ['getEvaluateStudents']),
  },
  methods: {
    ...mapActions('evaluate', ['fetchEvaluationCriteria']),
    ...mapActions('evaluateStudent', ['fetchEvaluateStudents', 'saveEvaluateStudent']),
    openDialog(evaluation) {
      this.dialog = true
      this.currentEvaluation = evaluation
      this.evaluationCriteria = evaluation.evaluate_criteria || []
    },
    closeDialog() {
      this.dialog = false
      this.$refs.criterialForStudent.reset()
      this.selectedStudent = null
      this.selectedStudentIndex = null
      this.evaluationCriteria = []
      this.currentEvaluation = null
    },
    async selectStudent(student, index) {
      this.selectedStudent = student
      this.selectedStudentIndex = index

      // Load existing evaluation data for the selected student
      const params = {
        student: student.id,
        evaluate: this.currentEvaluation.id,
      }
      await this.fetchEvaluateStudents(params)
      const existingEvaluation = this.getEvaluateStudents

      if (existingEvaluation && existingEvaluation.length > 0) {
        const studentEvaluation = existingEvaluation[0]
        this.evaluationCriteria.forEach((criteria) => {
          const existingCriteria = studentEvaluation.value.find((c) => c.id === criteria.id)
          if (existingCriteria) {
            criteria.value = existingCriteria.value
          }
        })
      } else {
        // Reset criteria values if no existing evaluation
        this.evaluationCriteria.forEach((criteria) => {
          criteria.value = null
        })
      }
    },
  },
}
</script>

<style scoped>
.evaluation-criteria-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.evaluation-criteria-card .v-card__text {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
